import { useEffect, useRef, useState } from 'react';

export const useScrollEdges = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const startSentinelRef = useRef<HTMLDivElement | null>(null);
  const endSentinelRef = useRef<HTMLDivElement | null>(null);
  const [isStartReached, setIsStartReached] = useState(true);
  const [isEndReached, setIsEndReached] = useState(true);

  useEffect(() => {
    const container = containerRef.current;
    const startSentinel = startSentinelRef.current;
    const endSentinel = endSentinelRef.current;

    if (!container || !startSentinel || !endSentinel) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === startSentinel) {
            setIsStartReached(entry.isIntersecting);
          }

          if (entry.target === endSentinel) {
            setIsEndReached(entry.isIntersecting);
          }
        });
      },
      { root: container, threshold: 0 },
    );

    observer.observe(startSentinel);
    observer.observe(endSentinel);

    return () => observer.disconnect();
  }, []);

  return { containerRef, startSentinelRef, endSentinelRef, isStartReached, isEndReached };
};
